exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "th[data-v-2033e034],td[data-v-2033e034]{vertical-align:middle}", "", {"version":3,"sources":["/home/circleci/repo/app/components/commons/orders/MasterClientTable.vue"],"names":[],"mappings":"AAgHA,wCACE,qBAAA,CAAA","file":"MasterClientTable.vue?vue&type=style&index=0&id=2033e034&scoped=true&lang=sass&","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nth, td\n  vertical-align: middle\n"],"sourceRoot":""}]);

// exports
